<template>
  <div id="resultWord-edit">

    <IForm ref="formInline" :model="edit" :elem="editElem" :rules="editRule" :loading="loading.form"
           :btn-loading="loading.btn" :submit="false"  @on-submit="toSubmit">

      <div slot="extend">
        <Row>
          <!--
          <Col span="12"><FormItem :label-width="50" label="名称" prop="name"><Input v-model="edit.name" type="text" placeholder="请输入名称"/></FormItem></Col>
          -->
          <Col span="12">
            <FormItem :label-width="70" label="助记词" prop="errorConfigId">
              <el-select v-model.trim="edit.errorConfigId" placeholder="助记词" filterable size="small" style="width: 100%;">
                <el-option v-for="item in mnemonicPhrases" :key="item.id" :label="item.evaluation" :value="item.id" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="12"><FormItem :label-width="70" label="编码" prop="code"><Input v-model="edit.code" type="text" placeholder="请输入编码"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem :label-width="70" label="原因" prop="reason"><Input v-model="edit.reason" type="textarea" placeholder="请输入原因" :rows="3" maxlength="200" show-word-limit/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem :label-width="70" label="建议" prop="propose"><Input v-model="edit.propose" type="textarea" placeholder="请输入建议" maxlength="500" show-word-limit/></FormItem></Col>
        </Row>
      </div>

    </IForm>

  </div>
</template>
<script>

import {_save, _get, _baseData} from "@/services/screeningConfig/resultWord.js";
export default {
  name: "ResultWordEdit",
  data() {
    return {
      edit: {
        name: "",
        errorConfigId: "",
        code: "",
        reason: "",
        propose: "",
        status: 1,
      },
      init: "",
      loading: {
        form: false,
        btn: false
      },
      mnemonicPhrases: [],
      editElem: [],
      editRule: {
        errorConfigId: [
          {required: true, message: '请选择助记词'},
        ],
        /*name: [
          {required: true, message: '名称不能为空', trigger: 'blur'},
          {maxlength: 50, message: "名称长度不能超过50", trigger: 'blur'}
        ],*/
        reason: [
          {required: true, message: '原因不能为空', trigger: 'blur'},
          {maxlength: 200, message: "原因长度不能超过200", trigger: 'blur'}
        ],
        propose: [
          {required: true, message: '建议不能为空', trigger: 'blur'},
          {maxlength: 500, message: "建议长度不能超过500", trigger: 'blur'}
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    baseData(){
      this.mnemonicPhrases = [];
      _baseData().then(res =>{
        if (res.errcode === 1 && res.data) {
          this.mnemonicPhrases = res.data;
        }
      })
    },
    handleModal(isCreate, title, row) {
      this.baseData();

      this.$refs["formInline"].handleReset();
      if (isCreate) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      this.loading.form = true;
      _get({id: row.id}).then(res => {
        this.edit = Object.assign({}, res.data);
        this.loading.form = false;
        this.$forceUpdate();
      })
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      this.$Loading.start();
      this.loading.btn = true;

      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        }else{
          this.$message.error(res.errmsg);
        }
        this.$Loading.finish();
        this.loading.btn = false;
      }).catch(() => {
        this.$Loading.error();
        this.loading.btn = false;
      });
    }
  }
};
</script>
<style lang="postcss" scoped>

</style>
